import { Component, OnInit, ViewChild } from "@angular/core";
import { SolicitacaoTecnicaService } from "../../../../../services/solicitacao-tecnica.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../../../services/auth.service";
import { NotaAuditoriaExecucaoService } from "../../../../../services/nota-auditoria-execucao.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { EnumRecursoPerfil } from "../../../../../models/enum/recurso-perfil.enum";
import { EnumAcaoRecurso } from "../../../../../models/enum/acao-recurso.enum";
import { INotaAuditoriaExecucaoModel } from "../../../../../models/nota-auditoria-execucao.model";
import Swal from "sweetalert2";
import { IAuditorModel } from "../../../../../models/alocar-equipe-component";
import { MatTableDataSource } from "@angular/material/table";
import { OsaService } from "../../../../../services/osa.service";
import { SharedService } from "../../../../../services/shared.service";
import { OsaExecucaoService } from "src/app/services/osa-execucao.service";

export interface IAuditorSimplificado {
  id?: number;
  auditorId: string;
  nomeAuditor: string;
}
@Component({
  selector: 'app-imprimir-nota-auditoria-execucao',
  templateUrl: './imprimir-nota-auditoria-execucao.component.html',
  styleUrls: ['./imprimir-nota-auditoria-execucao.component.scss']
})
export class ImprimirNotaAuditoriaExecucaoComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("maxLengthEditor") private angularEditor: any;
  public model: INotaAuditoriaExecucaoModel = {} as INotaAuditoriaExecucaoModel;
  public equipe: IAuditorSimplificado[] = [];
  public nomeAuditor: string = "";
  public today = new Date();


  constructor(
    public authService: AuthService,
    public notaAuditoriaService: NotaAuditoriaExecucaoService,
    public sharedaService: SharedService,
    public route: ActivatedRoute,
    private osaService: OsaService,
    public router: Router,
    public osaExecucaoService: OsaExecucaoService
  ) {

    this.model.id = Number(this.route.snapshot.paramMap.get("id"));
  }
  ngOnInit(): void {
    this.obterPorId()
  }

  public async obterPorId() {
    this.notaAuditoriaService.obterPorId(this.model?.id).then(async (res) => {
      if (res.sucesso) {

        this.model = res.dados;
        console.log(this.model);

        this.obterAlocarEquipe(this.model?.osaId);
        this.nomeAuditor = this.sharedaService.getNomeAuditor() 
        if(!this.nomeAuditor){
          this.nomeAuditor = await this.obterDados();
        }
        

      } else {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  public async obterDados() {
    const res = await this.osaExecucaoService.obterPorId(this.model.id);
    if (res.sucesso) {
      return res.dados.osa.nomeAuditor;
    }
    return '';
  }

  public obterAlocarEquipe(idOsa: number) {
    this.osaService.obterAlocarEquipeOsaId(idOsa).then((res) => {
      let auditoresSelecionados: IAuditorSimplificado[] = res.dados.map((a) => {
        return {
          auditorId: a.auditorId,
          nomeAuditor: a.nomeAuditor,
          id: a.id,
        };
      });
      auditoresSelecionados = auditoresSelecionados.filter(function (a) {
        return (
          !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true)
        );
      }, Object.create(null));

      this.equipe = auditoresSelecionados;
    });
  }
  public cancelar() {
    window.history.back()
  }

  public print() {
    window.print();
  }
}
